export const REGULATION_TYPE = {
  main: 'DEFAULT',
  recurring: 'RECURRING',
  vasPaywallService: 'VAS_PAYWALL_SERVICE',
  vasPayerPaywallDataSharing: 'VAS_PAYER_PAYWALL_DATA_SHARING',
}
